import type { AuthUser, LoginResult } from '@/types/auth';
import type { LeadershipTier } from '@/types/user';

export function normalizeAuthUser(user: LoginResult['user'] & Record<string, unknown>): AuthUser {
  const normalized: AuthUser = {
    id: String(user.id),
    phone: String(user.phone),
    name: String(user.name),
    role: user.role as AuthUser['role'],
    departmentId: String(user.departmentId),
    leaderId: user.leaderId != null ? String(user.leaderId) : null,
    canManageTeam: Boolean(user.canManageTeam),
  };

  if (typeof user.leadershipTier === 'string') {
    normalized.leadershipTier = user.leadershipTier as LeadershipTier;
  }

  return normalized;
}

export function preserveLeadershipTier(next: AuthUser, previous: AuthUser | null): AuthUser {
  if (previous?.leadershipTier !== undefined && next.leadershipTier === undefined) {
    return { ...next, leadershipTier: previous.leadershipTier };
  }
  return next;
}
